import React from 'react';
import {
  EnvironmentOutlined,
  FileTextOutlined,
  MailOutlined,
  PhoneOutlined,
  UserOutlined,
} from '@ant-design/icons';

export interface ICustomerDetails {
  name: string;
  email: string;
  phone: string;
  address: string;
  postCode: string;
  projectRef: string;
  projectType: string;
}

interface CustomerDetailsSectionProps {
  customerDetails: ICustomerDetails;
}

const Row: React.FC<{ icon: React.ReactNode; label: string; value: string }> = ({
  icon,
  label,
  value,
}) => (
  <div className="flex items-center gap-3">
    <span className="text-gray-400 text-lg flex-shrink-0">{icon}</span>
    <span className="text-sm text-gray-600 min-w-[100px]">{label}</span>
    <p className="text-sm text-gray-900 font-medium">{value}</p>
  </div>
);

export const CustomerDetailsSection: React.FC<CustomerDetailsSectionProps> = ({
  customerDetails,
}) => (
  <div className="bg-white rounded-lg p-6">
    <h3 className="text-lg text-left font-semibold text-gray-900 mb-4">Customer Details</h3>
    <div className="space-y-3">
      <Row icon={<UserOutlined />} label="Name" value={customerDetails.name} />
      <Row icon={<MailOutlined />} label="Email" value={customerDetails.email} />
      <Row icon={<PhoneOutlined />} label="Phone" value={customerDetails.phone} />
      <Row icon={<EnvironmentOutlined />} label="Address" value={customerDetails.address} />
      <Row icon={<EnvironmentOutlined />} label="Post Code" value={customerDetails.postCode} />
      <Row icon={<FileTextOutlined />} label="Project Type" value={customerDetails.projectType} />
      <Row icon={<FileTextOutlined />} label="Project Ref." value={customerDetails.projectRef} />
    </div>
  </div>
);
